import React from "react";
import { SLTableCell } from "~/pages/Sistema/componentes/SistemaList";
import { ThisTable, ThisContainer } from "./styles";

function TableComponent() {
  return (
    <>
      <ThisContainer>
        <ThisTable>
          <SLTableCell className="col-w-1" name="codigo" inputfilter>
            Id
          </SLTableCell>
          <SLTableCell name="titulo" inputfilter>
            Título
          </SLTableCell>
          <SLTableCell
            name="descricao"
            className="col-w-4 truncate"
            inputfilter
          >
            Descrição
          </SLTableCell>
          <SLTableCell name="valor" inputfilter>
            Valor
          </SLTableCell>
        </ThisTable>
      </ThisContainer>
    </>
  );
}

export default TableComponent;
